export function getCanonicalURL(url) {
  return url.replace(/(^[^(\\?|#)]+)(?:\\?|#).*/, '$1')
}
